module.exports = __webpack_public_path__ + "static/media/screenshot(42).573e1c0f.jpg";